import { createEmitter } from '@srm/ui/lib/valueStore';

const announcements = createEmitter<string>();

/**
 * Объявить диктору текст плашки поддержки. Live-область плашки, смонтированная сразу с текстом, NVDA и JAWS не
 * озвучивают — текст уходит в постоянную область провайдера показа (`SupportLiveRegion`).
 */
export function announceSupport(text: string): void {
    announcements.emit(text);
}

/** Подписка постоянной live-области. Возвращает отписку. */
export const onSupportAnnouncement = (listener: (text: string) => void): (() => void) =>
    announcements.subscribe(listener);
